import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import d1 from "../../../../assets/images/CT/d1.png";
import d2 from "../../../../assets/images/CT/d2.png";
import d3 from "../../../../assets/images/CT/d3.png";
import d4 from "../../../../assets/images/CT/d4.png";
import d5 from "../../../../assets/images/CT/d5.png";
import d6 from "../../../../assets/images/CT/d6.png";
const set_dice_image = (n) => {
  switch (n) {
    case 1:
      return <img className="dice-image" src={d1} />;

    case 2:
      return <img className="dice-image" src={d2} />;

    case 3:
      return <img className="dice-image" src={d3} />;

    case 4:
      return <img className="dice-image" src={d4} />;

    case 5:
      return <img className="dice-image" src={d5} />;

    case 6:
      return <img className="dice-image" src={d6} />;
  }
};

const Question = (props) => {
  const { dice, active_player_details, space_result } = props;
  const dice_sum = _.sum(dice);
  const playingParams = _.get(props, "paramsReducer.gameObj.2_playing");
  return (
    <>
      <div className="question-wrapper">
        <div className="dice-image-wrappper">
          {set_dice_image(dice[0])}
          {set_dice_image(dice[1])}
        </div>
        {/* <div className="question-bottom-content"> */}
        <h2>
          {active_player_details?.display_name}
          <br /> rolled a {dice_sum} and landed on {space_result}
        </h2>
        <p>{playingParams.question_posed}.</p>
        {/* </div> */}
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Question);
